export interface IWorkflowActivityService {
  recordWorkflowStart(customerId: string, workflowId: string, userId: string): void;
  recordWorkflowStop(
    customerId: string,
    workflowId: string,
    userId: string,
    isComplete: boolean,
  ): void;
  recordStepStart(
    customerId: string,
    workflowId: string,
    stepId: string,
    userId: string,
  ): void;
  recordStepStop(
    customerId: string,
    workflowId: string,
    stepId: string,
    userId: string,
    isComplete: boolean,
  ): void;
  flushPending(): Promise<void>;
  dispose(): Promise<void>;
}

export const WORKFLOW_ACTIVITY_SERVICE = Symbol.for("Campfire.WorkflowActivityService");
